var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12L12 3L22 12H19V20H5V12H2ZM12 18L12.72 17.34C15.3 15 17 13.46 17 11.57C17 10.03 15.79 8.82 14.25 8.82C13.38 8.82 12.55 9.23 12 9.87C11.45 9.23 10.62 8.82 9.75 8.82C8.21 8.82 7 10.03 7 11.57C7 13.46 8.7 15 11.28 17.34L12 18Z",
    fill: "#333D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeart);
export default __webpack_public_path__ + "static/media/home-heart.b975b8c6199f430bffd9f5966631bfcf.svg";
export { ForwardRef as ReactComponent };